import type { ButtonHTMLAttributes, ReactNode } from "react"
import { cn } from "@/lib/cn"

// Branded button — variants map to Valet's color tokens. Never bake a hex
// here; if a new visual surface is needed, extend the variants object so
// every page reaches it the same way.

export type ButtonVariant = "red" | "gold" | "white" | "ghost"
export type ButtonSize    = "sm" | "md"

const VARIANT: Record<ButtonVariant, string> = {
  red:   "bg-brand-red text-white hover:bg-brand-redDeep shadow-redGlow",
  gold:  "border border-vip-gold/30 bg-vip-goldMute text-vip-goldSoft hover:bg-vip-gold/20",
  white: "bg-white text-app-bg hover:bg-app-text",
  ghost: "border border-border bg-white/5 text-app-text hover:bg-white/10",
}

const SIZE: Record<ButtonSize, string> = {
  sm: "px-3 py-1.5 text-xs",
  md: "px-4 py-2 text-sm",
}

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant
  size?: ButtonSize
  children: ReactNode
}

export function Button({ variant = "red", size = "md", className, children, ...rest }: Props) {
  return (
    <button
      {...rest}
      className={cn(
        "inline-flex items-center justify-center rounded-control font-medium transition disabled:opacity-50 disabled:pointer-events-none",
        VARIANT[variant],
        SIZE[size],
        className,
      )}
    >
      {children}
    </button>
  )
}
